<template>
  <div>
    <v-btn
      @click="dialog = true"
      color="primary"
      class="ml-2"
    >
      Novo
    </v-btn>
    <SysDialog
      v-model="dialog"
      titulo="Novo modulo para o menu de parametrização"
      @click:primary="salvarModulo()"
    >
      <Form :item="item" />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { salvarModulosConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: { SysDialog, Form },
  data: () => ({
    dialog: false,
    item: {
      descricao: '',
      icon: '',
      link: ''
    }
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
      this.item.descricao = '';
    },
    salvarModulo() {
      this.$store.dispatch(
        'loading/addRequisicao',
        salvarModulosConfiguracaoMenuParametrizacao(this.item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-modulo'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
